import { Cart, PolicyCartInput } from '../types';
import { cartPolicies } from './registry';
import { runPolicies } from './runPolicies';
import { CartPolicyMeta, CartPolicyResult } from './types';

export function runClientPolicies(
  input: PolicyCartInput,
  cart: Cart | null,
  meta: CartPolicyMeta,
): CartPolicyResult {
  const clientPolicies = cartPolicies.filter(
    (p) => p.scope === 'shared' || p.scope === 'client',
  );
  return runPolicies(clientPolicies, input, cart, meta);
}
